// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__9eQED","unreadBadge":"styles_unreadBadge__mttHF","modalContent":"styles_modalContent__cdL0N","modal":"styles_modal__1Egzd"};